/** IDs dos status da clicheria */
export enum PedidoClicheriaStatusID {
   DESENVOLVER_ARTE = 1,
   APROVAR_ARTE = 2,
   ARTE_REPROVADA = 3,
   REVISAR_CLICHE = 4,
   INUTILIZAR_CLICHE = 5,
   ARTE_APROVADA = 6,
   SOLICITADA_ALTERACAO_ARTE = 7,
   OUTRO = 99
}

export namespace PedidoClicheriaStatusID {
    /** Verifica se é o status Desenvolver Arte */
    export function isStatusDesenvolverArte(id: number): boolean {
        return id === PedidoClicheriaStatusID.DESENVOLVER_ARTE;
    }
    /** Verifica se é o status Aprovar Arte */
    export function isStatusAprovarArte(id: number): boolean {
        return id === PedidoClicheriaStatusID.APROVAR_ARTE;
    }
    /** Verifica se é o status Arte Reprovada */
    export function isStatusArteReprovada(id: number): boolean {
        return id === PedidoClicheriaStatusID.ARTE_REPROVADA;
    }
    /** Verifica se é o status Revisar Clichê */
    export function isStatusRevisarCliche(id: number): boolean {
        return id === PedidoClicheriaStatusID.REVISAR_CLICHE;
    }
    /** Verifica se é o status Inutilizar Clichê */
    export function isStatusInutilizarCliche(id: number): boolean {
        return id === PedidoClicheriaStatusID.INUTILIZAR_CLICHE;
    }
    /** Verifica se é o status Arte Aprovada */
    export function isStatusArteAprovada(id: number): boolean {
        return id === PedidoClicheriaStatusID.ARTE_APROVADA;
    }
    /** Verifica se é o status Solicitada Alteração Arte */
    export function isStatusSolicitadaAlteracaoArte(id: number): boolean {
        return id === PedidoClicheriaStatusID.SOLICITADA_ALTERACAO_ARTE;
    }
    /** Verifica se é o status Outro */
    export function isStatusOutro(id: number): boolean {
        return id === PedidoClicheriaStatusID.OUTRO;
    }
}
